export const muiLink = {
  defaultProps: {
    underline: 'hover',
  },
  styleOverrides: {
    button: {
      verticalAlign: 'unset',
    },
  },
};
